import PageHero from "@/components/feature/PageHero";
import LaunchOfferSection from "@/components/feature/LaunchOfferSection";
import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/public";

const subscriptionSteps = [
  { icon: "ri-user-add-line", title: "Créer votre espace", description: "Inscrivez-vous et choisissez votre profil." },
  { icon: "ri-gift-line", title: "Profiter de l'essai", description: "6 mois gratuits avec accès complet à toutes les fonctionnalités." },
  { icon: "ri-rocket-2-line", title: "Utiliser la plateforme", description: "Accédez immédiatement à tous les modules, sans limitation." },
  { icon: "ri-vip-diamond-line", title: "Choisir une formule", description: "Au terme de l'essai, choisissez la formule adaptée à votre patrimoine." },
];

export default function SubscriptionPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="Abonnement"
        current="Abonnement"
        title="6 mois gratuits pour démarrer sans limite"
        description="Pendant notre offre de lancement, créez votre compte gratuitement et profitez d'un accès complet, sans limites de formule."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <LaunchOfferSection />
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="container-page">
          <Reveal>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-center text-foreground-950">
              Comment profiter de l'offre
            </h2>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-4">
            {subscriptionSteps.map((step, index) => (
              <Reveal key={step.title} delay={index * 90} className="h-full">
                <div className="card-lift h-full rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300">
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                      <i className={`${step.icon} text-xl`} aria-hidden="true" />
                    </span>
                    <span className="font-heading text-2xl font-semibold text-background-400">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-4 text-base font-heading font-semibold text-foreground-950">{step.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600">{step.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <Reveal>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-center text-foreground-950">
              Questions sur l'abonnement
            </h2>
          </Reveal>
          <div className="mx-auto mt-10 max-w-3xl">
            <Accordion items={faqs.slice(6, 11)} />
          </div>
        </div>
      </section>
    </div>
  );
}